import React from 'react';
import styled from '@emotion/styled';

interface IProps {
	space: string;
	isVertical: boolean;
}

export default function Space({ space, isVertical }: IProps) {
	return <Wrapper space={space} isVertical={isVertical} />;
}

const Wrapper = styled.div`
	padding-top: ${(props: IProps) => (props.isVertical ? props.space : 0)};
	padding-left: ${(props: IProps) => (props.isVertical ? 0 : props.space)};
`;
